import { EffectComposer, Bloom, ChromaticAberration, Noise, Vignette } from '@react-three/postprocessing';
import { BlendFunction } from 'postprocessing';
import { useMemo } from 'react';
import { Vector2 } from 'three';

import { useEngineRuntimeStore } from '../store/engineRuntimeStore';

export function PostEffects() {
  const bloomIntensity = useEngineRuntimeStore((s) => s.bloomIntensity);
  const vignetteAmount = useEngineRuntimeStore((s) => s.vignetteAmount);
  const grainOpacity = useEngineRuntimeStore((s) => s.grainOpacity);
  const chromaticAberration = useEngineRuntimeStore((s) => s.chromaticAberration);

  const chromaticOffset = useMemo(() => new Vector2(0.000455, 0.000315), []);

  return (
    <EffectComposer multisampling={0}>
      <Bloom mipmapBlur intensity={bloomIntensity} luminanceThreshold={0.42} luminanceSmoothing={0.38} />
      <Vignette eskil={false} offset={0.22} darkness={vignetteAmount} />
      <Noise premultiply opacity={grainOpacity} blendFunction={BlendFunction.SOFT_LIGHT} />
      {chromaticAberration ? (
        <ChromaticAberration offset={chromaticOffset} />
      ) : <></>}
    </EffectComposer>
  );
}
